module.exports = __webpack_public_path__ + "img/메인로고.1aaf3d2e.jpg";